module.exports = __webpack_public_path__ + "/static/assets/50dc258da84162c7bdc3403db0e6c72f.gif";